import { VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';

import { RootState } from '../reducks/store/store';
import { getUserInfo } from '../reducks/users/selectors';
import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { signOut } from '../reducks/users/operations';
import { LogOutButton } from '../components/Uikit/LogOutButton';
import { PrimaryOutlineButton } from '../components/Uikit/PrimaryOutlineButton';
import { useNavigate } from 'react-router-dom';

const Mypage: VFC = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state: RootState) => state);
  const userInfo = getUserInfo(selector);
  const navigate = useNavigate();

  const email = userInfo.email || '未登録';
  const address = userInfo.address || '未登録';
  const birthdayYear = userInfo.birthdayYear || '未登録';
  const birthdayMonth = userInfo.birthdayMonth || '未登録';
  const phone = userInfo.phone || '未登録';
  const gender = userInfo.gender || '未登録';

  const birthdayYearMonth =
    birthdayYear !== '未登録' && birthdayMonth !== '未登録'
      ? `${birthdayYear}年${birthdayMonth}月`
      : '未登録';

  let genderText = '';
  if (gender === 'male') {
    genderText = '男性';
  } else if (gender === 'female') {
    genderText = '女性';
  } else if (gender === 'neither') {
    genderText = '答えたくない';
  } else {
    genderText = '未登録';
  }

  return (
    <section className='mx-auto my-0 max-w-xl relative py-0 px-4 text-center w-full sm:max-w-5xl'>
      <h1 className='text-pandacco text-2xl mt-0 mx-auto mb-4'>アカウント情報</h1>
      <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">姓（カタカナ）</TableCell>
              <TableCell align="left">{userInfo.lastNameKana}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">名（カタカナ）</TableCell>
              <TableCell align="left">{userInfo.firstNameKana}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">メールアドレス<br />（変更不可）</TableCell>
              <TableCell align="left">{email}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">携帯電話番号</TableCell>
              <TableCell align="left">{phone}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">生年月日</TableCell>
              <TableCell align="left">{birthdayYearMonth}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">性別</TableCell>
              <TableCell align="left">{genderText}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">都道府県</TableCell>
              <TableCell align="left">{address}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <PrimaryButton label={'編集する'} onClick={() =>  navigate('/user/my-page/edit')} />
      <PrimaryOutlineButton label={'メニューに戻る'} onClick={() =>  navigate('/')} />
      <LogOutButton label={'ログアウト'} onClick={() =>  dispatch(signOut(navigate))} />
    </section>
  );
};
export default Mypage;
